module.exports = __webpack_public_path__ + "img/ownerappLogo.a63fcd40.png";